import { create } from 'zustand'

export interface DevLogEntry {
  id: number
  ts: number
  kind: 'error' | 'warn' | 'info'
  message: string
  detail?: unknown
}

interface DevLogStore {
  entries: DevLogEntry[]
  push: (e: Omit<DevLogEntry, 'id' | 'ts'>) => void
  clear: () => void
}

let nextId = 1

export const useDevLog = create<DevLogStore>((set) => ({
  entries: [],
  push: (e) =>
    set((s) => ({ entries: [...s.entries, { ...e, id: nextId++, ts: Date.now() }].slice(-50) })),
  clear: () => set({ entries: [] }),
}))
